<template>
  <div class="subheader" :class="{ accent: hasAccentColor }">
    <h1 class="text-overlay">{{ title }}</h1>
  </div>
</template>

<script>
export default {
  name: 'Subheader',
  props: {
    title: {
      type: String,
      default: '',
    },
    hasAccentColor: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      responsive_enabled: false,
    }
  },
  mounted() {
    window.addEventListener('resize', () => {
      if (window.innerWidth >= 768) {
        this.responsive_enabled = false
      }
    })
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/base';
@import '../styles/variables';
@import '../styles/mixins/labels';

.subheader {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  z-index: 1;
  background-color: $secondary;
  padding: 1rem;

  &.accent {
    background-color: $accent-inverted;
  }
}

.text-overlay {
  margin: 0;
  word-wrap: normal;
  color: $off-white;
  font-size: 20px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
}
</style>
